/* ns-cart.js — native Shopify cart for the nude-shy template
   Uses /cart/add.js, /cart/change.js, /cart.js. Checkout = native /checkout.
   No custom storefront API, no custom checkout. Progressive enhancement:
   product forms still work without JS (native POST to /cart). */
(function () {
  'use strict';

  var root = document.documentElement;
var moneyFormat = '{{amount}} RSD';

  /* ── money (mirrors Shopify.formatMoney) ───────────────────── */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = moneyFormat;
    function fmtNum(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    switch (placeholder) {
      case 'amount': value = fmtNum(cents, 2); break;
      case 'amount_no_decimals': value = fmtNum(cents, 0); break;
      case 'amount_with_comma_separator': value = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmtNum(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmtNum(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmtNum(cents, 0, ' ', ''); break;
      default: value = fmtNum(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ── toast ─────────────────────────────────────────────────── */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.querySelector('.toast');
      if (!toastEl) return;
    }
    toastEl.querySelector('span:last-child').textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);
  }

  /* ── drawer ────────────────────────────────────────────────── */
  function openDrawer() {
    var d = document.querySelector('.cart-drawer');
    var o = document.querySelector('.cart-overlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = document.querySelector('.cart-drawer');
    var o = document.querySelector('.cart-overlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }

  function phClass(item) {
    var t = (item.product_type || '').toLowerCase();
    if (item.featured_image && item.featured_image.url) return '';
    if (t.indexOf('skin') > -1 || t.indexOf('spf') > -1) return 'tonal';
    return 'dark';
  }

  /* ── collab shipping market (EU / RS) ──────────────────────────
     A "shipping product" carries an option named "shipping" whose value
     contains "eu" or "rs". The market is sticky per cart: whatever shipping
     items are already in the bag decide it. */
  function marketOfValue(val) {
    val = (val || '').toLowerCase();
    if (val.indexOf('eu') > -1) return 'EU';
    if (val.indexOf('rs') > -1) return 'RS';
    return '';
  }
  function itemMarket(it) {
    var m = '';
    (it.options_with_values || []).forEach(function (o) {
      if ((o.name || '').toLowerCase() === 'shipping') {
        var mm = marketOfValue(o.value);
        if (mm) m = mm;
      }
    });
    return m;
  }
  function cartMarket(cart) {
    var m = '';
    (cart.items || []).forEach(function (it) {
      var mm = itemMarket(it);
      if (mm) m = mm;
    });
    return m;
  }

  // Keep the drawer's market row + window.NS_MARKET in sync with the cart.
  function renderMarket(cart) {
    var el = document.querySelector('.cart-market');
    var m = cartMarket(cart);
    window.NS_MARKET = m;
    if (!el) return;
    if (!m) {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }
    var other = m === 'EU' ? 'RS' : 'EU';
    el.hidden = false;
    el.setAttribute('data-ns-market', m);
    el.innerHTML =
      '<span class="cart-market__label">izabran market · <strong>' + m + '</strong></span>' +
      '<button type="button" class="cart-market__switch" data-ns-market-switch="' + other + '">pređi na ' + other + '</button>';
  }

  // fetch + cache /products/{handle}.js so we can resolve counterpart variants
  var _productCache = {};
  function getProduct(handle) {
    if (_productCache[handle]) return Promise.resolve(_productCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { _productCache[handle] = p; return p; });
  }

  // Find the variant for the same product + same non-shipping options, but with
  // the shipping option set to the target market. null if that combo doesn't exist.
  // The shipping option index comes from the cart line item's options_with_values
  // (reliable {name,value} objects, same source as itemMarket) — NOT from prod.options,
  // whose shape varies between Shopify serializations. Variant option VALUES line up by
  // position with options_with_values, so we match index-for-index.
  function counterpartId(item, target) {
    return getProduct(item.handle).then(function (prod) {
      var ov = item.options_with_values || [];
      var shipIdx = -1;
      ov.forEach(function (o, i) {
        if ((o.name || '').toLowerCase() === 'shipping') shipIdx = i;
      });
      if (shipIdx < 0) return null;
      var want = ov.map(function (o) { return o.value; });
      var found = (prod.variants || []).find(function (v) {
        var opts = v.options || [];
        if (opts.length !== want.length) return false;
        return opts.every(function (val, i) {
          if (i === shipIdx) return marketOfValue(val) === target;
          return val === want[i];
        });
      });
      return found ? found.id : null;
    });
  }

  // Swap every shipping line item to its counterpart in the target market.
  function switchMarket(target, btn) {
    if (btn) btn.disabled = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ship = (cart.items || []).filter(function (it) { return !!itemMarket(it); });
        if (!ship.length) return refresh(false);
        return Promise.all(ship.map(function (it) {
          return counterpartId(it, target).then(function (id) { return { it: it, id: id }; });
        })).then(function (pairs) {
          var adds = [], updates = {};
          pairs.forEach(function (p) {
            if (p.id) { adds.push({ id: p.id, quantity: p.it.quantity }); updates[p.it.key] = 0; }
          });
          if (!adds.length) throw new Error('nema zamene za taj market');
          // add counterparts first (atomic), then remove the originals by line key
          return addVariant(adds[0].id, adds[0].quantity, adds.slice(1))
            .then(function () {
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ updates: updates })
              });
            })
            .then(function () { return refresh(false); })
            .then(function () { toast('market · ' + target); });
        });
      })
      .catch(function (err) {
        if (btn) btn.disabled = false;
        toast(err.message || 'greška');
      });
  }

  function renderDrawer(cart) {
    var itemsEl = document.querySelector('.cart-items');
    var footEl = document.querySelector('.cart-foot');
    var titleEl = document.querySelector('.cart-hd h3');
    if (!itemsEl) return;
    if (titleEl) titleEl.textContent = 'your bag · ' + cart.item_count;
    renderMarket(cart);

    if (!cart.items.length) {
      itemsEl.innerHTML =
        '<div class="cart-empty"><p>bag je prazan.</p>' +
        '<button class="btn ghost tiny" data-ns-close>nastavi shopping</button></div>';
      if (footEl) footEl.style.display = 'none';
      return;
    }
    if (footEl) footEl.style.display = '';

    itemsEl.innerHTML = cart.items.map(function (it) {
      var img = it.featured_image && it.featured_image.url
        ? '<div class="ph" style="background-image:url(' + it.featured_image.url + ');background-size:cover;background-position:center"></div>'
        : '<div class="ph ' + phClass(it) + '"></div>';
      var opts = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.value; }).join(' · ');
      var sub = it.product_title && it.product_title !== it.title ? '' : '';
      return (
        '<div class="cart-row" data-key="' + it.key + '">' +
          img +
          '<div class="meta">' +
            '<div class="nm">' + it.product_title + '</div>' +
            (opts ? '<div class="opt">' + opts + '</div>' : '') +
            '<div class="qty">' +
              '<button data-ns-qty="' + (it.quantity - 1) + '" aria-label="−">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button data-ns-qty="' + (it.quantity + 1) + '" aria-label="+">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="right">' +
            '<div class="pr">' + formatMoney(it.final_line_price) + '</div>' +
            '<button class="rm" data-ns-remove>ukloni</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    var sub = document.querySelector('.cart-foot .row span:last-child');
    if (sub) sub.textContent = formatMoney(cart.items_subtotal_price);
    var tot = document.querySelector('.cart-foot .total .val');
    if (tot) tot.textContent = formatMoney(cart.total_price);

    // free-shipping hint (threshold in minor units from data attr, EUR cents default 15000)
    var threshold = parseInt(root.getAttribute('data-ns-free-ship') || '0', 10);
    var ship = document.querySelector('.cart-foot .ship');
    if (ship && threshold > 0) {
      ship.textContent = cart.total_price >= threshold
        ? 'besplatna dostava uključena'
        : 'dodaj ' + formatMoney(threshold - cart.total_price) + ' za besplatnu dostavu';
    }
  }

  function refresh(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        renderDrawer(cart);
        if (open) openDrawer();
        return cart;
      });
  }

  function updateCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  /* ── add to cart (single) ──────────────────────────────────── */
  function addVariant(id, qty, extraItems) {

  var items = [
    {
      id: id,
      quantity: qty || 1
    }
  ];

  if (extraItems && extraItems.length) {
    items = items.concat(extraItems);
  }

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: items
    })
  }).then(function (r) {
    if (!r.ok) {
      return r.json().then(function (e) {
        throw new Error(e.description || 'error');
      });
    }
    return r.json();
  });
  }

  /* ── delegated events ──────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // open / close drawer
    if (t.closest('[data-ns-cart-open]')) { e.preventDefault(); refresh(true); return; }
    if (t.closest('[data-ns-close]') || t.closest('.cart-overlay') || t.closest('.cart-hd .x')) {
      e.preventDefault(); closeDrawer(); return;
    }

    // mobile menu
    if (t.closest('.nav-burger')) {
      document.querySelector('.ns-mobile-menu').classList.toggle('open');
      document.body.style.overflow =
        document.querySelector('.ns-mobile-menu').classList.contains('open') ? 'hidden' : '';
      return;
    }
    if (t.closest('.ns-mobile-menu a')) {
      document.querySelector('.ns-mobile-menu').classList.remove('open');
      document.body.style.overflow = '';
      return;
    }

    // option pills
    var size = t.closest('.ns-size');
    if (size) {
      size.parentElement.querySelectorAll('.ns-size').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      size.setAttribute('aria-pressed', 'true');
      syncVariant(size.closest('[data-ns-card]'));
      return;
    }
    var sw = t.closest('.pcard .swatch');
    if (sw) {
      sw.parentElement.querySelectorAll('.swatch').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      sw.setAttribute('aria-pressed', 'true');
      syncVariant(sw.closest('[data-ns-card]'));
      return;
    }

    // qty +/- in drawer
    var qbtn = t.closest('[data-ns-qty]');
    if (qbtn) {
      var key = qbtn.closest('.cart-row').getAttribute('data-key');
      changeQty(key, parseInt(qbtn.getAttribute('data-ns-qty'), 10));
      return;
    }
    var rm = t.closest('[data-ns-remove]');
    if (rm) {
      var rkey = rm.closest('.cart-row').getAttribute('data-key');
      changeQty(rkey, 0);
      return;
    }

    // market switch (drawer) — swap all shipping items to the other market
    var msw = t.closest('[data-ns-market-switch]');
    if (msw) { e.preventDefault(); switchMarket(msw.getAttribute('data-ns-market-switch'), msw); return; }

    // checkout
    if (t.closest('[data-ns-checkout]')) { e.preventDefault(); window.location.href = '/checkout'; return; }
  });

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); renderDrawer(cart); });
  }

  /* ── variant resolution per card ───────────────────────────── */
  function syncVariant(card) {
    if (!card) return;
    var data = card._variants || JSON.parse(card.querySelector('.ns-variant-data').textContent);
    card._variants = data;

    // Gather chosen values keyed by their TRUE 1-based option position (data-ns-position),
    // mirroring the shipping popup's resolve(). Options not shown as pills — single-value
    // options and the hidden "shipping" option — stay unconstrained, so a shipping product
    // resolves across BOTH shipping variants for the chosen colour/size.
    var chosen = {};
    card.querySelectorAll('[data-ns-opt]').forEach(function (row) {
      var pos = parseInt(row.getAttribute('data-ns-position'), 10);
      var sel = row.querySelector('[aria-pressed="true"]');
      if (pos && sel) chosen[pos] = sel.getAttribute('data-value');
    });
    function matches(v) {
      return Object.keys(chosen).every(function (p) {
        return v.options[parseInt(p, 10) - 1] === chosen[p];
      });
    }
    var candidates = data.filter(matches);
    // Prefer an available variant for the chosen options; the combo counts as buyable when
    // ANY matching variant is available (e.g. RS in stock while EU is sold out) so the
    // shipping-open button is never disabled out from under a reachable variant.
    var match = candidates.find(function (v) { return v.available; })
      || candidates[0]
      || data.find(function (v) { return v.available; })
      || data[0];
    var available = !!(match && match.available);

    var form = card.querySelector('.ns-add-form');
    if (form) {
      form.querySelector('input[name="id"]').value = match.id;
      var btn = form.querySelector('[data-ns-add-btn]');
      var price = card.querySelector('[data-ns-price]');
      if (price) price.textContent = formatMoney(match.price);
      if (btn) {
        if (available) {
          btn.disabled = false;
          var prefix = btn.getAttribute('data-ns-add-prefix') || 'add ·';
          btn.querySelector('[data-ns-add-label]').textContent = prefix + ' ' + formatMoney(match.price);
        } else {
          btn.disabled = true;
          btn.querySelector('[data-ns-add-label]').textContent = 'rasprodato';
        }
      }
    }
  }

  /* ── intercept add forms (AJAX, stay on page) ──────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.ns-add-form');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('input[name="id"]').value;
    var qty = parseInt((form.querySelector('input[name="quantity"]') || {}).value || '1', 10);
    var btn = form.querySelector('[data-ns-add-btn]');
    if (btn) btn.disabled = true;
    var extraItems = [];

document.querySelectorAll('.upsell-checkbox:checked').forEach(function(cb){
  extraItems.push({
    id: cb.value,
    quantity: 1
  });
});

addVariant(id, qty, extraItems)
      .then(function () { return refresh(true); })
      .then(function () { toast('added to bag'); })
      .catch(function (err) { toast(err.message || 'greška'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* ── build-your-own → native cart permalink ────────────────── */
  window.NS_buildPermalink = function (variantIds, discountCode) {
    if (!variantIds.length) return '/cart';
    var path = '/cart/' + variantIds.map(function (id) { return id + ':1'; }).join(',');
    return discountCode ? path + '?discount=' + encodeURIComponent(discountCode) : path;
  };

  /* ── init ──────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ns-card]').forEach(syncVariant);
    refresh(false);
  });
})();
